import { render, staticRenderFns } from "./BillingList.vue?vue&type=template&id=de2b1960&scoped=true"
import script from "./BillingList.vue?vue&type=script&lang=js"
export * from "./BillingList.vue?vue&type=script&lang=js"
import style0 from "./BillingList.vue?vue&type=style&index=0&id=de2b1960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2b1960",
  null
  
)

export default component.exports